import { z } from 'zod';
import { bff, createBFFHandlers } from '~/framework/bff';
import { getServerSideMonolithClient } from '~/framework';
import {
   getSingleEntry as getSingleEntryFromMonolith,
   GetSingleEntryResponse,
} from '~/monolith-api';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

export type { GetSingleEntryResponse };

const singleEntrySchema = z.object({
   entryid: z.number(),
});

export async function getSingleEntry(entryid: number, options: CommonRequestOptions) {
   return await getSingleEntryFromMonolith(entryid, options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { entryid } = singleEntrySchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getSingleEntry(entryid, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getSingleEntryFromClient = (entryid: number): ReturnType<typeof getSingleEntry> => {
   return bff()
      .post('/signoffs/getSingleEntry', {
         entryid,
      })
      .then(response => response.data);
};
